import { EventTriggerSource } from '@enums';
import { FlowModuleFragment } from '@graphql/generated/graphql';
import { ExperimentDefinitions } from '@lib/experiments';
import { FC } from 'react';

import { FlowRenderer } from './FlowRenderer';
import { FlowProvider } from '../contexts/FlowContext';

interface Props {
    module: FlowModuleFragment;
    triggerSource: EventTriggerSource;
    experiment?: ExperimentDefinitions['onboarding-registration-identifier'];
    onExit?: () => void;
}

export const Flow: FC<Props> = ({
    module,
    triggerSource,
    experiment,
    onExit,
}) => (
    <FlowProvider
        module={module}
        triggerSource={triggerSource}
        experiment={experiment}
        onExit={onExit}
    >
        <FlowRenderer />
    </FlowProvider>
);
